module.exports = __webpack_public_path__ + "img/thanos-pal-8PWY6aTanhQ-unsplash.882c7d84.jpg";